module.exports = __webpack_public_path__ + "static/media/LeandroA.7db75146.png";